var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"address-discovery"},[_c('v-container',[_c('service-autodiscovery')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }